import type { ClassValue } from "clsx"
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { Capacitor } from "@capacitor/core"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// On native, Active Storage returns relative URLs which the WebView resolves
// against the app bundle instead of the Rails server. Prefix them with the
// API base URL so images load correctly.
export function mediaUrl(url: string | null | undefined): string {
  if (!url) return ''
  if (!Capacitor.isNativePlatform()) return url
  if (url.startsWith('http') || url.startsWith('blob:') || url.startsWith('data:')) return url
  return `${import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3000'}${url}`
}
